import pathnames from "./constants/pathnames";
import { isMarketplaceEnabled } from "./config";
import ForgotPassword from "./modules/authentication/forgot-password";
import ForgotPasswordSuccess from "./modules/authentication/forgot-password.success";
import ResetPassword from "./modules/authentication/reset-password";
import SignIn from "./modules/authentication/signin";
import Dashboard from "./modules/dashboard";
import Home from "./modules/home";
import Organizations from "./modules/organizations";
import OrganizationDetails from "./modules/organizations/organization-details";
import SingleInvoice from "./modules/organizations/invoices-single";
import Users from "./modules/users";
import SingleUser from "./modules/users/users-single";
import OrganizationAdministrators from "./modules/organizations/administrators";
import OrganizationFirsBusinesses from "./modules/organizations/firs-businesses";
import Administrators from "./modules/admin";
import Payments from "./modules/payments";
import Billing from "./modules/billing";
import AddBillingPlan from "./modules/billing/components/add-new";
import PushNotifications from "./modules/push-notifications";
import UserProfile from "./modules/settings/user-profile";
import UserPassword from "./modules/settings/user-password";
import TaxRates from "./modules/settings/tax-rates";
import CurrencyRates from "./modules/settings/currency-rates";
import SignOut from "./modules/authentication/signout";
import NotFound from "./modules/404";
import SingleAdministrator from "./modules/admin/users-single";
import AdminLogs from "./modules/admin/logs";
import OrganizationLogs from "./modules/organizations/logs";
import Referrers from "./modules/referrals/referrers";
import ReferrerDetails from "./modules/referrals/referrer-details";
import ReferralOrganizationDetails from "./modules/referrals/earnings-preview";
import Payouts from "./modules/payouts";
import ViewPayouts from "./modules/payouts/view-payout";
import ProcessPayout from "./modules/payouts/process-payout";
import ConfirmPayout from "./modules/payouts/confirm-payout";
import FundingHistory from "./modules/payouts/funding-history";
import Integrations from "./modules/integrations/Integrations";
import Interfaces from "./modules/integrations/Interfaces";
import UpdatePassword from "./modules/authentication/update-password";
import TransmissionsPage from "./modules/transmissions/Transmissions";
import TransmissionApiPage from "./modules/transmissions/Transmissions-Api";
import APILogs from "./modules/transmissions/APILogs";
import ViewTransmissionPage from "./modules/transmissions/ViewTransmission";
import ViewApiTransmissionPage from "./modules/transmissions/ViewApiTransmission";
import ViewApiLogPage from "./modules/transmissions/ViewApiLog";
import TransmittedInvoices from "./modules/transmissions/TransmittedInvoices";
import UnassignedInvoices from "./modules/transmissions/UnassignedInvoices";
import PromoCodesOverview from "./modules/promo-codes/overview";
import CreatePromoCode from "./modules/promo-codes/create-promo-code";
import RedemptionsHistory from "./modules/promo-codes/redemptions";
import MarketplaceIndex from "./modules/marketplace";
import MarketplaceAddons from "./modules/marketplace/addons";
import CreateMarketplaceItem from "./modules/marketplace/create-item";
import EditMarketplaceItem from "./modules/marketplace/edit-item";
import MarketplaceItemDetails from "./modules/marketplace/item-details";
import MarketplacePayments from "./modules/marketplace/payments";

const routes = [
  { title: "Home", private: false, path: pathnames.HOME, Component: Home },
  {
    title: "Sign In",
    private: false,
    path: pathnames.SIGN_IN,
    Component: SignIn,
  },
  {
    title: "Sign Out",
    private: false,
    path: pathnames.SIGN_OUT,
    Component: SignOut,
  },
  {
    title: "Forgot Password",
    private: false,
    path: pathnames.FORGOT_PASSWORD,
    Component: ForgotPassword,
  },
  {
    title: "Forgot Password Success",
    private: false,
    path: pathnames.FORGOT_PASSWORD_SUCCESS,
    Component: ForgotPasswordSuccess,
  },
  {
    title: "Update Password",
    private: false,
    path: pathnames.UPDATE_PASSWORD,
    Component: UpdatePassword,
  },
  {
    title: "Reset Password",
    private: false,
    path: pathnames.RESET_PASSWORD,
    Component: ResetPassword,
  },
  {
    title: "Dashboard",
    private: true,
    path: pathnames.DASHBOARD,
    Component: Dashboard,
  },
  {
    title: "Organizations",
    private: true,
    path: pathnames.ORGANIZATIONS,
    Component: Organizations,
  },
  {
    title: "Organizations",
    private: true,
    path: `${pathnames.ORGANIZATIONS}/:id`,
    Component: OrganizationDetails,
  },
  {
    title: "Organizations Administrators",
    private: true,
    path: `${pathnames.ORGANIZATIONS_ADMINS}/:id`,
    Component: OrganizationAdministrators,
  },
  {
    title: "Organization NRS Businesses",
    private: true,
    path: `${pathnames.ORGANIZATIONS_FIRS_BUSINESSES}/:id`,
    Component: OrganizationFirsBusinesses,
  },
  {
    title: "View Single Invoice",
    private: true,
    path: `${pathnames.ORGANIZATIONS_INVOICES}/:id`,
    Component: SingleInvoice,
  },
  {
    title: "Users",
    private: true,
    path: pathnames.USERS,
    Component: Users,
  },
  {
    title: "User Details",
    private: true,
    path: `${pathnames.USERS}/:id`,
    Component: SingleUser,
  },
  {
    title: "Referrals",
    private: true,
    path: pathnames.REFERRERS,
    Component: Referrers,
  },
  {
    title: "Referral Details",
    private: true,
    path: `${pathnames.REFERRERS}/:id`,
    Component: ReferrerDetails,
  },
  {
    title: "Referral Organizations",
    private: true,
    path: `${pathnames.REFERRALS_ORGANIZATIONS_PREVIEW}/:id`,
    Component: ReferralOrganizationDetails,
  },

  {
    title: "Administrators",
    private: true,
    path: pathnames.ADMINISTRATORS,
    Component: Administrators,
  },
  {
    title: "Administrators",
    private: true,
    path: `${pathnames.ADMINISTRATORS}/:id`,
    Component: SingleAdministrator,
  },
  {
    title: "Payments",
    private: true,
    path: pathnames.PAYMENTS,
    Component: Payments,
  },
  {
    title: "Billing",
    private: true,
    path: pathnames.BILLING,
    Component: Billing,
  },
  {
    title: "Add New Billing",
    private: true,
    path: pathnames.BILLING_ADD_NEW,
    Component: AddBillingPlan,
  },
  {
    title: "Payouts",
    private: true,
    path: pathnames.PAYOUTS,
    Component: Payouts,
  },
  {
    title: "Integrations",
    private: true,
    path: pathnames.INTEGRATIONS,
    Component: Integrations,
  },
  {
    title: "Transmissions",
    private: true,
    path: pathnames.TRANSMISSIONS,
    Component: TransmissionsPage,
  },
  {
    title: "Transmissions API",
    private: true,
    path: pathnames.API_TRANSMISSIONS,
    Component: TransmissionApiPage,
  },
  {
    title: "API Logs",
    private: true,
    path: pathnames.API_LOGS+"/:id",
    Component: APILogs,
  },
  {
    title: "View Transmissions",
    private: true,
    path: pathnames.TRANSMISSIONS + "/:id",
    Component: ViewTransmissionPage,
  },
  {
    title: "View API Log",
    private: true,
    path: pathnames.API_TRANSMISSIONS + "/:id/logs/:logId",
    Component: ViewApiLogPage,
  },
  {
    title: "View Transmissions API",
    private: true,
    path: pathnames.API_TRANSMISSIONS + "/:id",
    Component: ViewApiTransmissionPage,
  },
  {
    title: "Unassigned Invoices",
    private: true,
    path: pathnames.UNASSIGNED_INVOICES,
    Component: UnassignedInvoices,
  },
  {
    title: "Transmitted Invoices",
    private: true,
    path: pathnames.TRANSMITTED_INVOICES + "/:id",
    Component: TransmittedInvoices,
  },
  {
    title: "Interfaces",
    private: true,
    path: pathnames.INTERFACES,
    Component: Interfaces,
  },
  {
    title: "Remuneration",
    private: true,
    path: `${pathnames.PAYOUTS}/:id`,
    Component: ViewPayouts,
  },
  {
    title: "Process Payouts",
    private: true,
    path: `${pathnames.PAYOUTS__PROCESS}/:id`,
    Component: ProcessPayout,
  },
  {
    title: "Confirm Payouts",
    private: true,
    path: `${pathnames.PAYOUTS__CONFIRM}/:id`,
    Component: ConfirmPayout,
  },
  {
    title: "Funding History",
    private: true,
    path: pathnames.PAYOUTS__FUNDING_HISTORY,
    Component: FundingHistory,
  },
  {
    title: "Push Notifications",
    private: true,
    path: pathnames.PUSH_NOTIFICATIONS,
    Component: PushNotifications,
  },
  {
    title: "Promo Code Management",
    private: true,
    path: pathnames.PROMO_CODES,
    Component: PromoCodesOverview,
  },
  {
    title: "Promo Code Overview",
    private: true,
    path: pathnames.PROMO_CODES_OVERVIEW,
    Component: PromoCodesOverview,
  },
  {
    title: "Create Promo Code",
    private: true,
    path: pathnames.PROMO_CODES_CREATE,
    Component: CreatePromoCode,
  },
  {
    title: "Promo Code Redemptions",
    private: true,
    path: pathnames.PROMO_CODES_REDEMPTIONS,
    Component: RedemptionsHistory,
  },
  {
    title: "Marketplace",
    private: true,
    path: pathnames.MARKETPLACE,
    Component: MarketplaceIndex,
  },
  {
    title: "Marketplace Add-ons",
    private: true,
    path: pathnames.MARKETPLACE_ADDONS,
    Component: MarketplaceAddons,
  },
  {
    title: "New Marketplace Item",
    private: true,
    path: pathnames.MARKETPLACE_ADDON_CREATE,
    Component: CreateMarketplaceItem,
  },
  {
    title: "Edit Marketplace Item",
    private: true,
    path: pathnames.MARKETPLACE_ADDON_EDIT,
    Component: EditMarketplaceItem,
  },
  {
    title: "Marketplace Add-on Details",
    private: true,
    path: pathnames.MARKETPLACE_ADDON_DETAILS,
    Component: MarketplaceItemDetails,
  },
  {
    title: "Marketplace Payments",
    private: true,
    path: pathnames.MARKETPLACE_PAYMENTS,
    Component: MarketplacePayments,
  },
  {
    title: "Admin Profile",
    private: true,
    path: pathnames.SETTINGS_PROFILE,
    Component: UserProfile,
  },
  {
    title: "Change Password",
    private: true,
    path: pathnames.SETTINGS_CHANGE_PASSWORD,
    Component: UserPassword,
  },
  {
    title: "Tax Rates",
    private: true,
    path: pathnames.SETTINGS_TAX_RATES,
    Component: TaxRates,
  },
  {
    title: "Currency Rates",
    private: true,
    path: pathnames.SETTINGS_CURRENCY_RATES,
    Component: CurrencyRates,
  },
  {
    title: "Admin Logs",
    private: true,
    path: pathnames.ADMIN_LOGS,
    Component: AdminLogs,
  },
  {
    title: "Organization Logs",
    private: true,
    path: pathnames.ORGANIZATION_LOGS,
    Component: OrganizationLogs,
  },
  {
    title: "404 - Not Found Page",
    private: false,
    path: "*",
    Component: NotFound,
  },
].filter((route) => isMarketplaceEnabled || !route.path.startsWith(pathnames.MARKETPLACE));

export default routes;
